import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const JackpotEntries = ()=>{
    const [jackpotEntries, setJackpotEntries] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`jackpotEntry?page=${page}`);
            //console.log(data);
            setJackpotEntries(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`jackpotEntry/${id}`);
            setJackpotEntries(jackpotEntries.filter((jackpotEntrie) => jackpotEntrie.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'JackpotEntries'}>
            <InnerNav createLink={'/jackpotEntrieCreate'} listLink={'/jackpotEntries'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Time In </th>
                                    <th className="px-4 py-3">Msisdn </th>
                                    <th className="px-4 py-3">Jackpot Amount </th>
                                    <th className="px-4 py-3">Stake </th>
                                    <th className="px-4 py-3">Drawn </th>
                                    <th className="px-4 py-3">BetId </th>
                                    <th className="px-4 py-3">Misc1 </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {jackpotEntries.map((jackpotEntry)=>{
                                         return(
                                             <tr key={jackpotEntry.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{jackpotEntry.id}</td>
                                                 <td className="px-4 py-3 text-sm">{jackpotEntry.time_in}</td>
                                                 <td className="px-4 py-3 text-sm">{jackpotEntry.msisdn}</td>
                                                 <td className="px-4 py-3 text-sm">{jackpotEntry.jackpot_amount}</td>
                                                 <td className="px-4 py-3 text-sm">{jackpotEntry.stake}</td>
                                                 <td className="px-4 py-3 text-sm">{jackpotEntry.drawn}</td>
                                                 <td className="px-4 py-3 text-sm">{jackpotEntry.bet_id}</td>
                                                 <td className="px-4 py-3 text-sm">{jackpotEntry.misc1}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/jackpotEntries/${jackpotEntry.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(jackpotEntry.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default JackpotEntries;